export default "__VITE_ASSET__BTFhVY8y__"